import { useEffect } from 'react';

import { useAppSelector } from 'dux/app/hooks';

import isFunction from 'lodash/fp/isFunction';

import { styled } from '@prose-ui/legacy';

import ScrollTracker from 'Containers/ScrollTracker';

import { percsTriptych } from 'assets/content/membership/subscriberPercs';

import { canSelectFreeProduct as canSelectFreeProductSelector } from 'dux/membership/selectors';

import FAQBlock from '../SharedComponents/FAQBlock';
import MembershipTicker from '../SharedComponents/MembershipTicker';
import { PercsTriptych } from '../SharedComponents/PercsTriptych';
import SubscriberHero from './SubscriberHero';
import SubscriberPercs from './SubscriberPercs';

const SubscriberLandingPageWrapper = styled('div')(_props => ({
  width: '100%',
}));

const SubscriberLandingPage = () => {
  useEffect(() => {
    if (isFunction(window.hj)) {
      window.hj('trigger', `membership_subscriber`);
    }
  }, [window.hj]);

  const canSelectFreeProduct = useAppSelector(canSelectFreeProductSelector);

  return (
    <SubscriberLandingPageWrapper data-testid="membership-subscriber-page">
      <ScrollTracker>
        <SubscriberHero />
        <MembershipTicker content={['your hair looks good today btw!']} />
        {canSelectFreeProduct ? <SubscriberPercs /> : <PercsTriptych content={percsTriptych} />}
        <FAQBlock />
      </ScrollTracker>
    </SubscriberLandingPageWrapper>
  );
};

export default SubscriberLandingPage;
